import { Component } from '@angular/core';
import { ZoningCodeService } from '../../core/services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IZoningCodeModel } from 'src/app/interfaces/zoning-code-model.interface';

@Component({
    standalone: false,
    selector: 'app-current-zoning-code',
    templateUrl: './current-zoning-code.component.html',
    styleUrls: ['./current-zoning-code.component.scss']

})
export class CurrentZoningCodeComponent {
    constructor(private readonly zoningCodeService: ZoningCodeService) {}

    zoningCode$: Observable<IZoningCodeModel> = this.zoningCodeService.zoningCodes.pipe(
        map(zoningCode => (zoningCode ? zoningCode[0] : null))
    );
}
